import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home";
import AddCatalogProduct from "@/views/AddCatalogProduct/AddCatalogProduct";
import Products from "@/views/Products";
import BulkUpdate from "@/views/BulkUpdate";
import SellerSubAccounts from "@/views/SellerSubAccounts/SellerSubAccounts";
import store from "@/store";
import CreateProduct from "@/views/CreateProduct/CreateProduct";
import AddSingleProduct from "@/views/AddSingleProduct/AddSingleProduct";
import { GIB_CONTROL, REDIRECTION } from "@/utils/enum/pageCheckControl";
import { sendUserInfo, sendMenuClickEvent } from "@/utils/ga4/helper";
import {
  NEW_PRODUCT_LIST_DESIGN_ENABLE,
  NEW_PRODUCT_CREATE_DESIGN_ENABLE,
  NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE,
  UMBRELLA_CAMPAIGN_ENABLED,
} from "@/utils/enum/configs";
import ProductDeal from "@/views/ProductDeal/ProductDeal";
import ProductDetail from "@/views/ProductDetail/ProductDetail";
import EarlySettlement from "@/views/EarlySettlement/EarlySettlement";
import UmbrellaCampaigns from "@/views/UmbrellaCampaigns/UmbrellaCampaigns";
import UmbrellaCampaignDetail from "@/views/UmbrellaCampaigns/UmbrellaCampaignDetail";
import JoinCampaign from "@/views/UmbrellaCampaigns/JoinCampaign";
import JoinCampaignBulk from "@/views/UmbrellaCampaigns/JoinCampaignBulk";
import ManageCampaign from "@/views/UmbrellaCampaigns/ManageCampaign";
import AddProductsToCampaign from "@/views/UmbrellaCampaigns/AddProductsToCampaign";
import NoPermission from "@/components/common/NoPermission/NoPermission";
import CategoryCommissionCampaigns from "@/views/CategoryCommissionCampaigns/CampaignsList";
import CampaignDetail from "@/views/CategoryCommissionCampaigns/CampaignDetail";
import {
  ADD_PRODUCT,
  ADD_CATALOG_PRODUCT,
  BULK_PRODUCT_UPLOAD,
  ADD_SINGLE_PRODUCT,
} from "@/utils/enum/menuId";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { pageType: "Ana Sayfa" },
  },
  {
    path: "/selleroffice/v2/product/products",
    name: "Products",
    component: Products,
    beforeEnter: [checkListingUrl],
  },
  {
    path: "/selleroffice/v2/product/create/bulk",
    name: "BulkUpdate",
    component: BulkUpdate,
    meta: {
      id: BULK_PRODUCT_UPLOAD,
    },
    beforeEnter: [checkBulkUrl, navigationChange],
  },
  {
    path: "/product-deal",
    name: "ProductDeal",
    component: ProductDeal,
  },
  {
    path: "/campaigns/umbrella",
    name: "UmbrellaCampaigns",
    component: UmbrellaCampaigns,
    beforeEnter: [checkUmbrellaCampaignPermission],
  },
  {
    path: "/campaigns/umbrella/detail",
    name: "UmbrellaCampaignDetail",
    component: UmbrellaCampaignDetail,
    beforeEnter: [checkUmbrellaCampaignPermission],
  },
  {
    path: "/campaigns/umbrella/join/:campaignId?",
    name: "JoinCampaign",
    component: JoinCampaign,
    props: true,
    beforeEnter: [checkUmbrellaCampaignPermission],
  },
  {
    path: "/campaigns/umbrella/join/:campaignId/bulk",
    name: "JoinCampaignBulk",
    component: JoinCampaignBulk,
    props: true,
    beforeEnter: [checkUmbrellaCampaignPermission],
  },
  {
    path: "/campaigns/umbrella/manage/:campaignId",
    name: "ManageCampaign",
    component: ManageCampaign,
    props: true,
    beforeEnter: [checkUmbrellaCampaignPermission],
  },
  {
    path: "/campaigns/umbrella/join/:campaignId/add-products",
    name: "AddProductsToCampaign",
    component: AddProductsToCampaign,
    props: true,
    beforeEnter: [checkUmbrellaCampaignPermission],
  },
  {
    path: "/no-permission",
    name: "NoPermission",
    component: NoPermission,
  },
  {
    path: "/selleroffice/v2/seller-sub-accounts-management",
    name: "SellerSubAccounts",
    component: SellerSubAccounts,
  },
  {
    path: "/selleroffice/v2/product/productDetail/:pid",
    name: "ProductDetail",
    component: ProductDetail,
    props: true,
  },
  {
    path: "/selleroffice/v2/product/create",
    name: "CreateProduct",
    meta: {
      id: ADD_PRODUCT,
    },
    component: CreateProduct,
    beforeEnter: [navigationChange],
  },
  {
    path: "/selleroffice/v2/product/create/single",
    name: "AddSingleProduct",
    component: AddSingleProduct,
    meta: {
      id: ADD_SINGLE_PRODUCT,
    },
    beforeEnter: [navigationChange],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
  {
    path: "/selleroffice/v2/product/create/catalog",
    name: "AddCatalogProduct",
    component: AddCatalogProduct,
    meta: {
      id: ADD_CATALOG_PRODUCT,
    },
    beforeEnter: [checkAddCatalogUrl, navigationChange],
  },
  {
    path: "/settlement/earlySettlement",
    name: "EarlySettlement",
    component: EarlySettlement,
  },
  {
    path: "/campaign/categoryCommission",
    name: "CategoryCommissionCampaigns",
    component: CategoryCommissionCampaigns,
  },
  {
    path: "/campaign/categoryCommission/:id",
    name: "CategoryCommissionCampaignDetail",
    component: CampaignDetail,
    props: true,
  },
  {
    path: "/campaign/categoryCommission/joined/:id",
    name: "CategoryCommissionCampaignDetailJoined",
    component: CampaignDetail,
    props: true,
  },
];
// process.env.BASE_URL location.pathname
const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const result = await store.dispatch("common/checkGIBSellerInfo");
  if (result.behaviour === REDIRECTION) {
    window.location.href = result.redirectionLink;
  } else if (
    (result.needsPasswordChange && to.path !== "/") ||
    (!result.subAccountManagement &&
      to.path === "/selleroffice/v2/seller-sub-accounts-management")
  ) {
    next("/");
  } else if (result.behaviour !== GIB_CONTROL.FORCE_APPROVE) {
    next();
  }
});

router.beforeEach(async () => await store.dispatch("common/getConfigList"));

router.beforeEach(() => {
  sendUserInfo(store.getters["auth/getUserInfos"]);
});

router.afterEach((to, from) => {
  const clickedMenuData = sessionStorage.getItem("clickedMenu");

  // clickedMenu yoksa event gönderme
  if (!clickedMenuData) {
    return;
  }

  const menuData = JSON.parse(clickedMenuData);
  const referrerPath = document.referrer
    ? new URL(document.referrer).pathname
    : "";

  let linkUrl = menuData.href || "";
  let button_name = menuData.label;

  const getMenuClickParams = () => {
    const baseParams = {
      link_url: linkUrl,
      page_path: referrerPath || "",
      button_name,
    };

    const userInfo = store.getters["auth/getUserInfos"] || {};
    const parentLabel = menuData.parentLabel || "";
    const childLabel = menuData.label || "";
    const fullButtonName = parentLabel
      ? `${parentLabel} > ${childLabel}`
      : childLabel;
    const pageType = menuData.pageType || '';

    return {
      ...baseParams,
      button_name: fullButtonName,
      page_type: pageType,
      seller_name: userInfo.username || "",
      seller_id: userInfo.sellerId || "",
    };
  };

  const sendEvent = () => {
    sendMenuClickEvent(getMenuClickParams());
  };

  // Event'i DOM tamamen yüklendikten sonra gönder
  if (document.readyState === "complete") {
    sendEvent();
  } else {
    window.addEventListener("load", sendEvent, { once: true });
  }

  sessionStorage.removeItem("clickedMenu");
});


async function navigationChange(to, from, next) {
  const result = await store.dispatch("navigation/onNavigationChange", {
    id: to.meta?.id,
  });

  if (result) {
    next();
  } else {
    next("/");
  }
}

const isConfigTrue = (configName) =>
  store.getters["common/getConfigList"][configName] === "true";

function checkUmbrellaCampaignPermission(to, from, next) {
  const configList = store.getters["common/getConfigList"];
  const isEnabled = configList[UMBRELLA_CAMPAIGN_ENABLED];

  if (isEnabled === true || isEnabled === "true") {
    next();
  } else {
    next("/no-permission");
  }
}

function checkListingUrl(to, from, next) {
  isConfigTrue(NEW_PRODUCT_LIST_DESIGN_ENABLE)
    ? next()
    : (location.href = "/selleroffice/product/products");
}

function checkAddCatalogUrl(to, from, next) {
  isConfigTrue(NEW_PRODUCT_CREATE_DESIGN_ENABLE) ? next() : next("/");
}

function checkBulkUrl(to, from, next) {
  isConfigTrue(NEW_BULK_PRODUCT_MANAGEMENT_DESIGN_ENABLE)
    ? next()
    : (location.href = "/selleroffice/integration/main");
}

export default router;
